import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Seo from "../components/Seo";
import Breadcrumbs from "../components/Breadcrumbs";
import { WhatsAppButton, BookButton } from "../components/CTAButtons";
import { AREAS } from "../data/content";
import { breadcrumbSchema, multiGraph } from "../components/Schema";

export default function AreasIndex({ onBook }) {
  const crumbs = [{ label: "Home", href: "/" }, { label: "Area guides" }];
  return (
    <>
      <Seo
        title="Bhubaneswar area guides for spa & wellness"
        description="Local context for finding a professional spa in Bhubaneswar — Patia, KIIT, Jaydev Vihar, Nayapalli, Chandrasekharpur, Infocity and the airport area."
        path="/areas/"
        jsonLd={multiGraph(breadcrumbSchema(crumbs))}
      />
      <section className="content-hero section-pad narrow">
        <Breadcrumbs items={crumbs} />
        <p className="eyebrow">Local knowledge</p>
        <h1>Spa & wellness, by area.</h1>
        <p className="large-copy">
          Bhubaneswar is many small cities inside one. These area guides pull together the practical details
          — where it's easy to get to, when to book, and what tends to work on a weekday evening or a Saturday afternoon.
        </p>
        <div className="actions-row">
          <BookButton onBook={onBook} label="Start enquiry" testid="areas-index-book" />
          <WhatsAppButton label="Ask on WhatsApp" source="areas_index" testid="areas-index-whatsapp" />
        </div>
      </section>
      <section className="section-pad">
        <div className="area-detail-grid">
          {AREAS.map((a, i) => (
            <Link to={`/areas/${a.slug}/`} key={a.slug} className="area-detail-card" data-testid={`areas-index-card-${i}`}>
              <div className="area-photo" style={{ backgroundImage: `url(${a.image})` }} />
              <div className="area-detail-copy">
                <span className="card-kicker">{a.kicker}</span>
                <h3>{a.name}</h3>
                <p>{a.intro.slice(0, 110)}…</p>
                <ArrowRight size={18} />
              </div>
            </Link>
          ))}
        </div>
      </section>
    </>
  );
}
